import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Activity, Lock, ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const CELLS = Array.from({ length: 53 * 7 }, (_, i) => {
  const x = Math.sin(i * 12.9898) * 43758.5453;
  const r = x - Math.floor(x);
  return r < 0.45 ? "bg-slate-100" : r < 0.62 ? "bg-rose-300" : r < 0.72 ? "bg-rose-500" : r < 0.88 ? "bg-emerald-300" : "bg-emerald-600";
});

export default function InsightsTeaser() {
  const { t } = useTranslation();
  return (
    <div data-testid="insights-teaser" className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-6">
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-xl bg-blue-100 text-blue-800 flex items-center justify-center"><Activity size={17} /></div>
        <div>
          <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold text-amber-700"><Sparkles size={9} /> {t("insights.teaser.tag")}</span>
          <h3 className="font-display font-bold text-lg text-slate-900 tracking-tight leading-tight">{t("insights.teaser.title")}</h3>
        </div>
      </div>
      <div className="relative mt-5 min-h-[260px] overflow-hidden">
        <div aria-hidden className="select-none blur-[3px] opacity-80 pt-6">
          <div className="flex flex-wrap gap-2 mb-4">
            {["+$4,820", "62%", "148", "+$1,240"].map((v, i) => (
              <span key={i} className="rounded-full border border-slate-200 px-3 py-1 text-xs font-mono font-semibold text-emerald-700">{v}</span>
            ))}
          </div>
          <div className="grid grid-flow-col grid-rows-7 gap-[3px] w-max">
            {CELLS.map((c, i) => <div key={i} className={`h-[11px] w-[11px] rounded-[2px] ${c}`} />)}
          </div>
        </div>
        <div className="absolute inset-0 flex items-center justify-center p-2">
          <div className="rounded-2xl bg-white/90 backdrop-blur-sm border border-slate-200 shadow-lg px-5 py-4 max-w-sm text-center">
            <Lock size={18} className="mx-auto text-amber-600" />
            <p className="mt-2 text-sm text-slate-700 leading-relaxed">{t("insights.teaser.body")}</p>
            <Link to="/pricing" data-testid="insights-teaser-cta">
              <Button className="mt-4 bg-blue-900 hover:bg-blue-800 text-white font-semibold h-10">
                {t("insights.teaser.cta")} <ArrowRight size={14} className="ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
